import { formField } from 'framework/components/hoc/formField';
import { ImageField } from './ImageField';

export default formField(ImageField);
